/**
 * Hooks React Query pour les System Alerts
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { alertsAPI } from '../services/alerts.service';

const ALERTS_KEY = 'system-alerts';
const METRICS_KEY = 'performance-metrics';

// ============ QUERIES ============

export function usePerformanceMetrics() {
  return useQuery({
    queryKey: [METRICS_KEY],
    queryFn: () => alertsAPI.getPerformanceMetrics(),
    refetchInterval: 30000, // Auto-refresh toutes les 30s
    staleTime: 10000,
  });
}

export function useActiveAlerts() {
  return useQuery({
    queryKey: [ALERTS_KEY, 'active'],
    queryFn: () => alertsAPI.getActiveAlerts(),
    refetchInterval: 15000, // Auto-refresh toutes les 15s
    staleTime: 5000,
  });
}

export function useAllAlerts() {
  return useQuery({
    queryKey: [ALERTS_KEY, 'all'],
    queryFn: () => alertsAPI.getAllAlerts(),
    refetchInterval: 30000,
    staleTime: 10000,
  });
}

// ============ MUTATIONS ============

export function useResolveAlert() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (alertId: string) => alertsAPI.resolveAlert(alertId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ALERTS_KEY] });
    },
  });
}
